import { ref } from 'vue'
import axios from 'axios'
import { defineStore } from 'pinia'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'

interface FlashPayload {
  type: string
  message: string
}
interface Root {
  root: boolean
}

export const useBulkUpdateInGmbStore = defineStore('bulkUpdateInGmbStore', () => {
  const { t } = useI18n()
  const store = useStore()
  const updateFlash = (payload: FlashPayload, root: Root) => store.dispatch('flash/updateFlash', payload, root)

  const bulkUpdateInGmbLoading = ref<boolean>(false)

  const prepareConnect = () => {
    bulkUpdateInGmbLoading.value = true
  }
  const stopConnect = () => {
    bulkUpdateInGmbLoading.value = false
  }

  const bulkUpdateInGmb = async ({ companyUuid, storeIds }: { companyUuid: string, storeIds: string[] }) => {
    prepareConnect()
    return axios
      .post(`/api/companies/${companyUuid}/location/stores/bulk_updates`, { store_ids: storeIds })
      .then(() => {
        updateFlash({ type: 'notice', message: t('messages.bulkUpdatedWithDelay', { value: t('models.store.modelName') }) }, { root: true })
        stopConnect()
      })
      .catch(err => {
        stopConnect()
        updateFlash({ type: 'alert', message: err }, { root: true })
        console.error(err)
      })
  }

  return { bulkUpdateInGmbLoading, bulkUpdateInGmb }
})
